import request from '@/utils/request'

let Help_qApi = {

  /*帮助中心问题列表*/
  list(data) {
    return request._post('/shop/plus.help_q.Index/index', data);
},
/*添加帮助中心问题*/
add(data) {
    return request._post('/shop/plus.help_q.Index/add', data);
},
/*修改帮助中心问题*/
edit(data) {
    return request._post('/shop/plus.help_q.Index/edit', data);
},
/*删除帮助中心问题*/
del(data) {
    return request._post('/shop/plus.help_q.Index/del', data);
},
/*帮助中心问题详情*/
detail(data) {
  return request._post('/shop/plus.help_q.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.help_q.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.help_q.Setting/getSetting', data, errorback);
    },
}
export default Help_qApi;



// WEBPACK FOOTER //
// ./src/api/help_q.js